<ps-ui-modal>
  <ps-ui-modal-body class="ps-modal-advanced-leave-as-is">
    <i
      class="fa fa-exclamation-circle exclamation-style"
      aria-hidden="true"
    ></i>
    <p class="lable-text">
      This project has Supplier Level Quota enabled, this means that you have
      manually edited the supplier distribution on this quota.
    </p>
    <br />
    <p class="lable-text">
      The adjustment you are about to make will result in a pro-rata
      distribution. This means that the adjustment will be applied on a pro-rata
      basis for the respective quota(s) and/or supplier distributions below this
      Goal Amount.
    </p>
    <div class="col-sm-12 text-right" *ngIf="!advancedOptions">
      <button
        class="btn btn-default advance-btn"
        (click)="advancedOptions = true"
        psUiGtagEvent
        trackOn="click"
        action="supplier_level_quota_edit_advanced"
        category="Survey_Edit_QBS"
      >
        ADVANCED...
      </button>
      <div class="setting-info">
        <i class="fa fa-info-circle info-style" aria-hidden="true"></i>
        <p class="advance-info">
          <span>
            Advanced Options include:<br />
            LEAVE AS IS:<br />
            Selecting this will keep your edited target, quotas and/or suppliers
            at their fixed value and will distribute the new number across rest
            of the suppliers.
          </span>
        </p>
      </div>
    </div>
    <div *ngIf="advancedOptions">
      <br />
      <h6><strong>Advanced Options</strong></h6>
      <div class="advance-info-div">
        <h6>LEAVE AS IS:</h6>
        <p class="lable-text">
          Selecting this will keep your edited target, quotas and/or suppliers
          at their fixed value and will distribute the new number across rest of
          the suppliers.
        </p>
      </div>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer>
    <button
      *ngIf="!advancedOptions"
      type="button"
      psUiButton
      color="secondary"
      (click)="close()"
      class="cancle-btn btn btn-default pull-right"
      psUiGtagEvent
      trackOn="click"
      action="supplier_level_quota_edit_cancel"
      category="Survey_Edit_QBS"
    >
      CANCEL
    </button>
    <button
      *ngIf="!advancedOptions"
      type="button"
      class="clear-btn btn btn-primary pull-left"
      psUiButton
      (click)="close('continue')"
      psUiGtagEvent
      trackOn="click"
      action="supplier_level_quota_edit_continue"
      category="Survey_Edit_QBS"
    >
      CONTINUE
    </button>
    <button
      *ngIf="advancedOptions"
      type="button"
      psUiButton
      color="secondary"
      (click)="advancedOptions = false"
      class="cancle-btn btn btn-default pull-right"
      psUiGtagEvent
      trackOn="click"
      action="supplier_level_quota_edit_cancel_advanced"
      category="Survey_Edit_QBS"
    >
      CANCEL
    </button>
    <button
      *ngIf="advancedOptions"
      type="button"
      class="clear-btn btn btn-primary pull-left"
      psUiButton
      (click)="close('continue-as-is')"
      psUiGtagEvent
      trackOn="click"
      action="supplier_level_quota_edit_continue_as_is"
      category="Survey_Edit_QBS"
    >
      CONTINUE with LEAVE AS-IS
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
